import baseFactProvider from './baseFactProvider';
import factProvider from './factProvider';

export default function analyticsConfig(initialState, baseConfig) {
  return {
    enabled: !!(initialState.account && initialState.account.name && baseConfig.baseUrl),
    endpoint: baseConfig.endpoint,
    appId: 'event-guestside-site',
    baseFactProvider,
    factProvider,
    ...baseConfig
  };
}

export * from './recordEventBuildWizardFacts';
